import {
  FiPhone,
  FiMapPin,
  FiBookOpen,
  FiUser,
  FiBriefcase,
} from "react-icons/fi";
import {
  Body,
  HeaderInfo,
  Section,
  Skill,
  SkillsList,
  StatusMessage,
} from "../../style/view.styles";
import {
  IconContainer,
  MetadataContainer,
  MetadataContent,
  MetadataItem,
  MetadataLabel,
  MetadataValue,
  OrganizationContainer,
} from "../../style/opportunity.details.style";
import LoginPrompt from "./LoginPrompt";
import FullButton from "../Buttons/FullButton";

const TalentDetailsBody = ({
  talent,
  user,
  isLoggedIn,
  setIsConnectModalOpen,
  isConnectModalOpen,
  isTalentContacted,
}) => {
  return (
    <Body>
      <HeaderInfo>
        <h1 className="font40 darkGreenColor extraBold">
          {talent.first_name} {talent.last_name}
        </h1>
        <OrganizationContainer>
          <IconContainer>
            <FiUser />
          </IconContainer>
          <MetadataContent>
            <MetadataLabel>Email</MetadataLabel>
            <MetadataValue>{talent.email}</MetadataValue>
          </MetadataContent>
        </OrganizationContainer>
      </HeaderInfo>

      <MetadataContainer>
        <MetadataItem>
          <IconContainer>
            <FiPhone />
          </IconContainer>
          <MetadataContent>
            <MetadataLabel>Phone</MetadataLabel>
            <MetadataValue>{talent.phone}</MetadataValue>
          </MetadataContent>
        </MetadataItem>

        <MetadataItem>
          <IconContainer>
            <FiMapPin />
          </IconContainer>
          <MetadataContent>
            <MetadataLabel>Location</MetadataLabel>
            <MetadataValue>{talent.location}</MetadataValue>
          </MetadataContent>
        </MetadataItem>

        <MetadataItem>
          <IconContainer>
            <FiBookOpen />
          </IconContainer>
          <MetadataContent>
            <MetadataLabel>Education</MetadataLabel>
            <MetadataValue>{talent.education_level}</MetadataValue>
          </MetadataContent>
        </MetadataItem>

        <MetadataItem>
          <IconContainer>
            <FiBriefcase />
          </IconContainer>
          <MetadataContent>
            <MetadataLabel>Preferred Industry</MetadataLabel>
            <SkillsList>
              {talent.preferred_industry.split(",").map((industry, index) => (
                <Skill key={index}>{industry.trim()}</Skill>
              ))}
            </SkillsList>
          </MetadataContent>
        </MetadataItem>
      </MetadataContainer>

      <Section>
        <h3 className="font24 extraBold">Bio</h3>
        <p className="font18" style={{ padding: "30px 0" }}>
          {talent.bio}
        </p>
      </Section>
      <Section>
        {!isLoggedIn && (
          <LoginPrompt
            message="Please log in to access the application form."
            buttonText="Go To Login"
          />
        )}
        {isLoggedIn && user.role === "organization" && !isTalentContacted && (
          <FullButton
            action={() => {
              setIsConnectModalOpen(!isConnectModalOpen);
            }}
            title={"Get in Touch"}
          />
        )}
        {isTalentContacted && (
          <StatusMessage type={"success"}>Message sent!</StatusMessage>
        )}
      </Section>
    </Body>
  );
};

export default TalentDetailsBody;
